/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-10-29 12:32:32                               *
 * @LastEditors           : Hamza Damene                                      *
 * @LastEditDate          : 2025-03-19 16:00:00                               *
 *****************************************************************************/

/* SUMMARY
 * Imports
 * initKeycloak: Initialize keycloak
 */

/* Imports */
import Keycloak from "keycloak-js";
import { env } from "../../env";
import { setSecureCookie } from "./cookies";
import { api } from "../api/api";
/***/

let kc: Keycloak | null = null;

/**
 * Stocke les informations de l'utilisateur dans des cookies sécurisés
 * en utilisant les données du token Keycloak
 * @param keycloak - Instance Keycloak
 */
function storeUserInfoInCookies(keycloak: Keycloak) {
  if (keycloak.tokenParsed) {
    // Extraire les rôles du token
    const roles = keycloak.tokenParsed.realm_access?.roles || [];

    setSecureCookie("userRoles", roles.join(","), 60); // expire après 60 minutes

    // Stocker l'ID utilisateur également si nécessaire
    if (keycloak.tokenParsed.sub) {
      setSecureCookie("userId", keycloak.tokenParsed.sub, 60);

      api
        .get(`admin/users/${keycloak.tokenParsed.sub}`)
        .then((userData: any) => {
          if (userData && userData.roles) {
            const userRoles = userData.roles;

            const allRoles = [...roles];

            // Ajouter les rôles qui ne sont pas déjà présents
            userRoles.forEach((role: string) => {
              if (!allRoles.includes(role)) {
                allRoles.push(role);
              }
            });

            setSecureCookie("userRoles", allRoles.join(","), 60);
          }
        })
        .catch((error: unknown) => {
          console.error(
            "Erreur lors de la récupération des rôles utilisateur:",
            error
          );
        });
    }
  }
}

/**
 * initKeycloak: Initialize keycloak
 * @return - keycloak instance
 */
export const initKeycloak = () => {
  if (!kc) {
    kc = new Keycloak({
      url: env.KEYCLOAK_URL,
      realm: `cf${localStorage.getItem("realm")}`,
      clientId: env.KC_CLIENT_ID,
    });

    // Configurer les event listeners pour la gestion des tokens
    kc.onAuthSuccess = () => {
      if (kc) {
        storeUserInfoInCookies(kc);
      }
    };

    kc.onAuthRefreshSuccess = () => {
      if (kc) {
        storeUserInfoInCookies(kc);
      }
    };
  }

  return kc;
};
/***/
